<template>
  <div id="app">
    <v-app>
      <div v-if="this.loginFlg">
        <MstrHedr />
      </div>
      <router-view/>
    </v-app>
  </div>
</template>

<script>
import MstrHedr from './components/modules/MstrHedr'
export default {
  components: {
    MstrHedr
  },
  name: 'App',

  computed: {
    loginFlg () { return this.$store.getters['appSetting/loginFlg'] }
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue